import { useMutation } from 'react-query';
import { httpService } from '../../../../services/http.service';
import { BASE_URL } from '../../../../constants/endpoints';

interface IPayload {
  name : string,
  amount : number,
  description : string
}

interface IProps {
  customerId: string;
  accountExternalId: string;
  serviceItemId: string;
  payload: IPayload;
}

export const useUpdateServiceItem = () => useMutation(
  'useUpdateServiceItem',
  async ({
    customerId, accountExternalId, serviceItemId, payload,
  }: IProps) => {
    const res = await httpService.put(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/invoice/serviceItem/${serviceItemId}`, { ...payload });
    return res.data;
  },
  { retry: 0 },
);
